import {
  ReactElement,
  useEffect,
  useState,
  Suspense,
  FC,
  createElement
} from 'react';
import { Provider } from 'mobx-react';

import toastsModel from '../../models/toasts';
import dataModel from '../../models/data';
import localeModel from '../../models/locale';
import spinnerOverlayModel from '../../models/spinnerOverlay';

import PageLoading from '../../components/PageLoading';
import SpinnerOverlay from '../../components/SpinnerOverlay';
import ToastManager from '../../components/ToastManager';

import './styles.scss';

interface AdminPageProps {
  payload: string;
}

export default function adminPage(component: FC) {
  return function AdminPage(props: AdminPageProps): ReactElement {
    const { payload } = props;
    const [initReady, setInitReady] = useState(false);

    useEffect(() => {
      const { toasts, toastsCode, data } = JSON.parse(
        decodeURIComponent(atob(payload))
      );

      dataModel.setup(data);

      const init = async () => {
        await localeModel.init();

        // toasts
        toastsModel.multiAdd(toasts);
        toastsModel.multiAddCode(toastsCode);

        setInitReady(true);
      };

      init().catch(() => {
        console.error('Failed to initialize Guest Service admin');
      });
    }, []);

    if (!initReady) return <PageLoading />;

    return (
      <Provider
        dataModel={dataModel}
        spinnerOverlayModel={spinnerOverlayModel}
        localeModel={localeModel}
      >
        <Suspense fallback={<PageLoading />}>
          <div className="admin-page">
            {createElement(component)}
            <SpinnerOverlay />
          </div>
          <ToastManager />
        </Suspense>
      </Provider>
    );
  };
}
